import { SchoolDetails } from './SchoolDetails';

export default SchoolDetails;